<template>
  <div>
    <div :class="mobile ? 'blue-section-mobile' : 'blue-section'">
      <div style="width: 100%; max-width: 1700px; margin: 0 auto;">
        <div class="footer-title">
          <h2>
            Ready to explore EPIWATCH<sup>®</sup>?
          </h2>
          <div class="content-grid">
            <div class="footer-one">
              <div>
                <img src="/general/globe.png" alt="Globe" class="footer-globe"/>
              </div>
              <p>We harness the power of AI and open-source data to capture early epidemic signals globally and enable early detection of epidemics, leading to prevention of global spread</p>
            </div>
            <div>
              <h4>Quick Links</h4>
                <RouterLink to="/about" href="" class="underlined">About Us</RouterLink><br/>
                <RouterLink to="/about" href="" class="underlined">Meet the Team</RouterLink><br/>
                <RouterLink to="/products" href="" class="underlined">Products</RouterLink>
            </div>
            <div>
              <h4>Further Information</h4>
                <a class="underlined" href="https://www.9news.com.au/national/ethereum-founder-gives-5-million-to-aussie-uni-for-pandemic-technology/3cf6b227-0250-4bc6-bc7b-8d8199f3b0d5">Balvi funds Shiba Inu OSINT intiative</a><br/>
                <RouterLink to="/media-releases" class="underlined">Media and Press Releases</RouterLink>
            </div>
            <div class="footer-sub">
              <h4>Brought to you by:</h4>
              <div class="footer-logo-container">
                <img src="/about/unsw-logo.png" :style="mobile ? 'width: 70%' : 'height: 40px;'" class="footer-logo" alt="unsw logo"/>
              </div>
              <div class="footer-logo-container">
                <img src="/about/kirby-logo.png" :style="mobile ? 'width: 70%' : 'height: 40px;'" class="footer-logo" alt="kirby logo"/>
              </div>
            </div>
            <div>
              <h4>Subscribe to EPISCOPE</h4>
              <p>Our weekly digest providing a global view of early epidemic signals and outgoing outbreak information.</p>
              <button class="subscribe-button">Subscribe</button>
              <div class="social-icons">
                <a href="https://twitter.com/EPIWATCH_bsp" target="_blank"><img height="20px" src="/general/twitter-logo.svg" style="margin-right: 5px" alt="x logo"/></a>
                <a href="https://www.facebook.com/ISER-Integrated-Systems-for-Epidemic-Response-1113681065343096" target="_blank"><img height="20px" src="/general/facebook-logo.svg" style="margin-right: 5px" alt="facebook logo"/></a>
                <a href="https://www.youtube.com/channel/UC9Q177fKqLbBVxFBfR8NtOA" target="_blank"><img height="20px" src="/general/youtube-logo.svg" alt="youtube logo"/></a>
              </div>
            </div>

          </div>
      </div>
      </div>
    </div>
    <div class="footer">
      <div :class="mobile ? 'footer-copyright-mobile' : 'footer-copyright'">© 2025 EPIWATCH<sup>®</sup>. All rights reserved.</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'AppFooter',
    data: () => ({
      mobile: null,
      windowWidth: null
    }),
    created() {
      window.addEventListener('resize', this.checkScreen);
      this.checkScreen();
    },
    destroy() {
      window.removeEventListener('resize', this.checkScreen)
    },
    methods: {
      checkScreen() {
        this.windowWidth = window.innerWidth;
        if (this.windowWidth <= 1000) {
          this.mobile = true;
        } else {
          this.mobile = false;
        }
        }
      }
  }
</script>
